export const TIME_SLOTS_CONTAINER_ID = 'TIME_SLOTS_CONTAINER_ID';

// warnings
export const CAMERA_ON_TIME_ERROR = `Cannot load camera's data. Please reload the page`;

// datetime formats
export const EE_TIMESTAMP_FORMAT = 'yyyyMMddHHmmss.SSS';
export const DATE_FNS_SECONDS_FORMAT = 't';
export const EE_TIME_FORMAT = 'hh:mm:ss a';
export const DOWNLOADER_TIME_FORMAT = 'h:mm:ss';
export const TIMELINE_LABEL_FORMAT = 'h:mm a';
export const TIMELINE_TOOLTIP_FORMAT = 'h:mm:ss a';

// options
export const TIMELINE_DURATION_OPTIONS = [
  { label: '1 Min', value: 0.017 },
  { label: '5 Min', value: 0.08 },
  { label: '15 Min', value: 0.25 },
  { label: '30 Min', value: 0.5 },
  { label: '1 Hr', value: 1 },
  { label: '2 Hr', value: 2 },
  { label: '4 Hr', value: 4 },
  { label: '8 Hr', value: 8 },
];

export const EE_DOWNLOAD_DURATION_OPTIONS = [
  { label: '1 Min', value: 1 },
  { label: '2 Min', value: 2 },
  { label: '3 Min', value: 3 },
  { label: '4 Min', value: 4 },
  { label: '5 Min', value: 5 },
  { label: '10 Min', value: 10 },
  { label: '20 Min', value: 20 },
  { label: '30 Min', value: 30 },
  { label: '1 Hour', value: 60 },
];

// EE requests
export const PROXY_URL = 'http://localhost:8080/';
export const EE_BASE_URL = 'https://login.eagleeyenetworks.com/';
export const EE_ASSET_LIST_VIDEO_PATH = 'asset/list/video';
